export default "__VITE_ASSET__DB_Wosdt__"